import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../../context/themeContext";

const Contact = (props) => {
  const { theme } = useTheme();
  const { emailAddress, setEmailAddress } = props;

  const handleEmailAddress = (event) => {
    setEmailAddress(event.target.value);
  };

  return (
    <Box className={styles.contact}>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.darkgrey.darkgrey600,
          fontWeight: "500",
        }}
      >
        Contact
      </Typography>
      <Box className={styles.inputField}>
        <TextField
          label="Email Address"
          value={emailAddress}
          onChange={handleEmailAddress}
          fullWidth
          sx={{
            bgcolor: theme.palette.lightgrey.lightgrey00,
          }}
        />
      </Box>
    </Box>
  );
};

export default Contact;
